import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { ProgressBarModule } from "../progress-bar/progress-bar.module";

import { PasswordStrengthValidatorDirective } from "./password-strength-validator.directive";
import { PasswordStrengthComponent } from "./password-strength.component";

const DIRECTIVES = [PasswordStrengthComponent, PasswordStrengthValidatorDirective];

@NgModule({
	imports: [CommonModule, GlobalUiModule, TranslateModule, ProgressBarModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class PasswordStrengthModule {}
